import Modal from 'components/Modal'
import SpecialLoyaltyRefundTx from 'views/MemberProfile/ManualTx/SpecialLoyaltyRefundTx'

type Props = {
  title: string | undefined
  open: boolean
  onClose: () => void
}

const ModalSpecialLoyaltyRefund = ({ title, open, onClose }: Props): JSX.Element => (
  <Modal open={open} title={title} onClose={onClose} noFooter>
    <SpecialLoyaltyRefundTx onClose={onClose} />
  </Modal>
)

export default ModalSpecialLoyaltyRefund